export const translations = {
    tr: {
        brand: "ASİS HOTELS",
        tagline: "Mekke & Medine'de Mübarek Konaklama",
        nav: {
            home: "Ana Sayfa",
            hotels: "Oteller",
            transfers: "Transfer",
            guides: "Rehberlik",
            services: "Hizmetler",
            flights: "Uçak Bileti",
            visa: "Vize",
            hajj: "Hac",
            realestate: "Emlak",
            map: "Harita",
            track: "Rezervasyon Sorgula",
            track_short: "Sorgula",
            track_line1: "Rezervasyon",
            about: "Hakkımızda",
            contact: "İletişim",
            admin: "Yönetim",
            login: "Giriş Yap",
            register: "Üye Ol",
            profile: "Hesabım",
            logout: "Çıkış",
        },
        hero: {
            title: "Mübarek Yolculuğunuz İçin Seçkin Konaklamalar",
            subtitle:
                "Mekke ve Medine'deki dikkatle seçilmiş 5 yıldızlı otellerimizle umre ibadetinizi huzur ve konfor içinde gerçekleştirin.",
            cta_book: "Otelleri İncele",
            cta_contact: "Bizimle İletişime Geç",
            search_city: "Şehir Seçin",
            search_all: "Tüm Oteller",
            mecca: "Mekke",
            medina: "Medine",
        },
        sections: {
            hotels_title: "Otellerimiz",
            hotels_subtitle: "Mekke ve Medine'de eşsiz konuma sahip seçkin tesislerimiz",
            why_title: "Neden Bizi Tercih Etmelisiniz?",
            why_subtitle: "Her detayda kalite ve güven",
            cta_title: "Mübarek Yolculuğunuza Hazır Mısınız?",
            cta_subtitle:
                "Bireysel umreciler ve tur şirketleri için özel fiyatlandırma. Hemen rezervasyon talebinizi iletin.",
        },
        why: [
            { title: "Stratejik Konum", desc: "Harem-i Şerif'e yürüme mesafesinde özenle seçilmiş oteller." },
            { title: "Şeffaf Fiyatlandırma", desc: "Bireysel ve toplu alımlar için net ve esnek fiyatlar." },
            { title: "Tur Şirketi Avantajı", desc: "Toplu rezervasyonlarda özel indirimler ve esnek koşullar." },
            { title: "7/24 Destek", desc: "WhatsApp üzerinden anlık yardım ve danışmanlık hizmeti." },
        ],
        trust: {
            secure_booking: { title: "Güvenli Rezervasyon", desc: "Onaylı ve güvenli rezervasyon süreci" },
            best_price: { title: "En İyi Fiyat Garantisi", desc: "Daha ucuz bulursanız eşliyoruz" },
            verified: { title: "Doğrulanmış Oteller", desc: "Ekibimiz tarafından yerinde denetlenmiş" },
            support: { title: "7/24 Türkçe Destek", desc: "WhatsApp'tan anında yanıt" },
            free_cancel: "Ücretsiz İptal",
            verified_short: "Doğrulanmış",
            live_support: "Canlı Destek",
            viewers_now: "kişi bakıyor",
            rooms_left: "Son {n} oda!",
            recently_booked: "rezervasyon yaptı",
        },
        home: {
            prayer_title: "Bugünün Namaz Vakitleri",
            prayer_subtitle: "Mekke ve Medine için güncel ezan vakitleri (Aladhan · Ümmülkura)",
            hotels_all: "Tüm Oteller",
            hotels_count: "{n} otel bulundu",
            sort_by: "Sırala",
            sort_popular: "Popüler",
            sort_price_asc: "Fiyat: Düşük → Yüksek",
            sort_price_desc: "Fiyat: Yüksek → Düşük",
            sort_rating: "Puana Göre",
            see_map: "Haritada Gör",
            new: "Yeni",
            deposit_notice_short: "Ücretsiz iptal",
            reviews_of10: "yorum · /10",
            faq_title: "Sıkça Sorulan Sorular",
            faq_subtitle: "Aklınıza takılan sorulara hızlı yanıtlar.",
            transfer_title: "Otobüs ve VIP Transfer",
            transfer_subtitle: "Havalimanı, otel ve şehirler arası konforlu transfer hizmetleri.",
            transfer_see_all: "Tümünü Gör",
            guides_kicker: "REHBERLİK HİZMETİMİZ",
            guides_title_line1: "Gruplara Rehberlik Yapacak",
            guides_title_line2: "Profesyonel Hocalarımız",
            guides_desc: "Umre ve Hac yolculuğunuzda, kutsal topraklarda mübarek ibadetlerinizin usul ve adabına uygun şekilde yerine getirilmesi için, alanında uzman ilim ehli hocalarımız gruplara profesyonelce rehberlik yapmaktadır.",
            guides_cta: "Hocalarımızı Tanıyın",
            guides_quote: "Kutsal topraklarda usul ve adaba uygun kulluk için yanınızdayız.",
            guides_quote_kicker: "İLMİ REHBERLİK",
            guide_feature_1_title: "Ehil Kadro",
            guide_feature_1_desc: "İlim ve tecrübe sahibi hocalar",
            guide_feature_2_title: "Grup Organizasyonu",
            guide_feature_2_desc: "Küçük ve büyük gruplara özel program",
            guide_feature_3_title: "Türkçe Rehberlik",
            guide_feature_3_desc: "Ana dilinde açık ve anlaşılır anlatım",
            guide_feature_4_title: "7/24 Yanınızda",
            guide_feature_4_desc: "Yolculuk boyunca aktif destek",
        },
        hotel_card: {
            per_night: "Gece başına",
            free_wifi: "Ücretsiz Wi-Fi",
            details_rooms: "Detay & oda tipleri",
            check_availability: "Müsaitliği Gör",
        },
        hotel: {
            view: "Detayları İncele",
            distance: "Harem'e Mesafe",
            from: "den itibaren",
            night: "gece",
            book_now: "Rezervasyon Yap",
            rooms_title: "Oda Tipleri",
            amenities: "Olanaklar",
            description: "Açıklama",
        },
        reservation: {
            title: "Rezervasyon Talebi",
            subtitle: "Talebinizi alır almaz WhatsApp üzerinden sizinle iletişime geçeceğiz",
            customer_type: "Müşteri Tipi",
            individual: "Bireysel",
            tour: "Tur Şirketi",
            company: "Şirket Adı",
            name: "Ad Soyad",
            phone: "Telefon (WhatsApp)",
            email: "E-posta",
            check_in: "Giriş Tarihi",
            check_out: "Çıkış Tarihi",
            room_type: "Oda Tipi",
            rooms_count: "Oda Sayısı",
            guests: "Misafir Sayısı",
            meal_plan: "Yemek Planı",
            meal: { none: "Yemek Yok", breakfast: "Kahvaltı", half_board: "Yarım Pansiyon", full_board: "Tam Pansiyon" },
            notes: "Ek Notlar",
            summary: "Fiyat Özeti",
            nights: "Gece",
            room_total: "Oda Ücreti",
            meal_total: "Yemek Ücreti",
            total: "Toplam",
            deposit_notice:
                "Rezervasyonunuzun kesinleşmesi için toplam tutarın %{percent}'i ön ödeme olarak IBAN üzerinden alınacaktır.",
            iban_info: "IBAN Bilgileri",
            submit: "Talebi Gönder",
            success_title: "Talebiniz Alındı",
            success_desc:
                "Rezervasyon talebiniz başarıyla iletildi. WhatsApp üzerinden detayları paylaşmak için aşağıdaki butona tıklayın.",
            send_whatsapp: "WhatsApp ile Onayla",
        },
        admin: {
            login_title: "Yönetici Girişi",
            email: "E-posta",
            password: "Şifre",
            login: "Giriş Yap",
            dashboard: "Gösterge Paneli",
            hotels: "Oteller",
            reservations: "Rezervasyonlar",
            occupancy: "Doluluk",
            settings: "Ayarlar",
            logout: "Çıkış Yap",
            stats: {
                total_hotels: "Toplam Otel",
                total_reservations: "Toplam Rezervasyon",
                pending: "Bekleyen",
                approved: "Onaylanmış",
                rejected: "Reddedilen",
                revenue: "Gelir (SAR)",
            },
            actions: { approve: "Onayla", reject: "Reddet", edit: "Düzenle", save: "Kaydet", cancel: "İptal" },
        },
        footer: {
            rights: "Tüm hakları saklıdır.",
            quick: "Hızlı Bağlantılar",
            contact_us: "İletişim",
        },
    },
    en: {
        brand: "ASIS HOTELS",
        tagline: "Sacred Stays in Makkah & Madinah",
        nav: {
            home: "Home",
            hotels: "Hotels",
            transfers: "Transfer",
            guides: "Guides",
            services: "Services",
            flights: "Flights",
            visa: "Visa",
            hajj: "Hajj",
            realestate: "Real Estate",
            map: "Map",
            track: "Track Reservation",
            track_short: "Track",
            track_line1: "Reservation",
            about: "About",
            contact: "Contact",
            admin: "Admin",
            login: "Sign In",
            register: "Sign Up",
            profile: "My Account",
            logout: "Sign Out",
        },
        hero: {
            title: "Distinguished Stays for Your Sacred Journey",
            subtitle:
                "Experience your Umrah in peace and comfort with our carefully curated 5-star hotels in Makkah and Madinah.",
            cta_book: "Browse Hotels",
            cta_contact: "Contact Us",
            search_city: "Select City",
            search_all: "All Hotels",
            mecca: "Makkah",
            medina: "Madinah",
        },
        sections: {
            hotels_title: "Our Hotels",
            hotels_subtitle: "Carefully selected properties with exceptional locations in Makkah and Madinah",
            why_title: "Why Choose Us",
            why_subtitle: "Quality and trust in every detail",
            cta_title: "Ready for Your Sacred Journey?",
            cta_subtitle: "Special pricing for individuals and tour companies. Submit your reservation request today.",
        },
        why: [
            { title: "Prime Location", desc: "Hotels within walking distance to the Haram." },
            { title: "Transparent Pricing", desc: "Clear and flexible prices for individuals and groups." },
            { title: "Tour Operator Benefits", desc: "Special discounts for group bookings." },
            { title: "24/7 Support", desc: "Instant help and consultancy via WhatsApp." },
        ],
        trust: {
            secure_booking: { title: "Secure Booking", desc: "Verified & secure booking process" },
            best_price: { title: "Best Price Guarantee", desc: "We'll match a lower price you find" },
            verified: { title: "Verified Hotels", desc: "On-site audited by our team" },
            support: { title: "24/7 Turkish & English Support", desc: "Instant reply on WhatsApp" },
            free_cancel: "Free Cancellation",
            verified_short: "Verified",
            live_support: "Live Support",
            viewers_now: "viewing now",
            rooms_left: "Only {n} rooms left!",
            recently_booked: "just booked",
        },
        home: {
            prayer_title: "Today's Prayer Times",
            prayer_subtitle: "Current adhan times for Makkah & Madinah (Aladhan · Umm al-Qura)",
            hotels_all: "All Hotels",
            hotels_count: "{n} hotels found",
            sort_by: "Sort",
            sort_popular: "Popular",
            sort_price_asc: "Price: Low → High",
            sort_price_desc: "Price: High → Low",
            sort_rating: "By Rating",
            see_map: "View on Map",
            new: "New",
            deposit_notice_short: "Free cancellation",
            reviews_of10: "reviews · /10",
            faq_title: "Frequently Asked Questions",
            faq_subtitle: "Quick answers to common questions.",
            transfer_title: "Bus & VIP Transfer",
            transfer_subtitle: "Comfortable transfer services between airport, hotel and cities.",
            transfer_see_all: "View All",
            guides_kicker: "OUR GUIDANCE SERVICE",
            guides_title_line1: "Professional Scholars",
            guides_title_line2: "Guiding Groups",
            guides_desc: "During your Umrah and Hajj journey, our qualified scholars professionally guide groups so your sacred worship is performed in accordance with proper etiquette and tradition.",
            guides_cta: "Meet Our Scholars",
            guides_quote: "Guiding you toward proper worship in the sacred lands.",
            guides_quote_kicker: "SCHOLARLY GUIDANCE",
            guide_feature_1_title: "Qualified Staff",
            guide_feature_1_desc: "Knowledgeable and experienced scholars",
            guide_feature_2_title: "Group Organization",
            guide_feature_2_desc: "Custom programs for small and large groups",
            guide_feature_3_title: "Multilingual Guidance",
            guide_feature_3_desc: "Clear explanation in Turkish & English",
            guide_feature_4_title: "24/7 With You",
            guide_feature_4_desc: "Active support throughout your journey",
        },
        hotel_card: {
            per_night: "Per night",
            free_wifi: "Free Wi-Fi",
            details_rooms: "Details & room types",
            check_availability: "Check Availability",
        },
        hotel: {
            view: "View Details",
            distance: "Distance to Haram",
            from: "from",
            night: "night",
            book_now: "Book Now",
            rooms_title: "Room Types",
            amenities: "Amenities",
            description: "Description",
        },
        reservation: {
            title: "Reservation Request",
            subtitle: "We will contact you via WhatsApp upon receiving your request",
            customer_type: "Customer Type",
            individual: "Individual",
            tour: "Tour Company",
            company: "Company Name",
            name: "Full Name",
            phone: "Phone (WhatsApp)",
            email: "Email",
            check_in: "Check-in Date",
            check_out: "Check-out Date",
            room_type: "Room Type",
            rooms_count: "Number of Rooms",
            guests: "Number of Guests",
            meal_plan: "Meal Plan",
            meal: { none: "No Meals", breakfast: "Breakfast", half_board: "Half Board", full_board: "Full Board" },
            notes: "Additional Notes",
            summary: "Price Summary",
            nights: "Nights",
            room_total: "Room Total",
            meal_total: "Meal Total",
            total: "Total",
            deposit_notice: "{percent}% of the total amount is required as deposit via bank transfer (IBAN).",
            iban_info: "IBAN Information",
            submit: "Submit Request",
            success_title: "Request Received",
            success_desc:
                "Your reservation request has been received. Click the button below to confirm via WhatsApp.",
            send_whatsapp: "Confirm via WhatsApp",
        },
        admin: {
            login_title: "Admin Login",
            email: "Email",
            password: "Password",
            login: "Sign In",
            dashboard: "Dashboard",
            hotels: "Hotels",
            reservations: "Reservations",
            occupancy: "Occupancy",
            settings: "Settings",
            logout: "Sign Out",
            stats: {
                total_hotels: "Total Hotels",
                total_reservations: "Total Reservations",
                pending: "Pending",
                approved: "Approved",
                rejected: "Rejected",
                revenue: "Revenue (SAR)",
            },
            actions: { approve: "Approve", reject: "Reject", edit: "Edit", save: "Save", cancel: "Cancel" },
        },
        footer: { rights: "All rights reserved.", quick: "Quick Links", contact_us: "Contact" },
    },
};

export const makeT = (lang) => (path) => {
    const parts = path.split(".");
    let v = translations[lang] || translations.tr;
    for (const p of parts) {
        if (v == null) return path;
        v = v[p];
    }
    return v == null ? path : v;
};

export const useT = makeT;
